import * as Yup from "yup";
import React, { useCallback, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import axios from "axios";
import { baseUrl } from "../../Api/baseUrl";
import { SUBSCRIPTION } from "../../Api/constantApi";
import { useFormik } from "formik";

import Directions from "../Popup/Directions";
import Modal from "./Modal";

import Call_Icon from "../../Assets/svg/call_icon.svg";
import Email_Icon from "../../Assets/svg/email_icon.svg";
import Location_Icon from "../../Assets/svg/location_icon.svg";
import CopyrightLogo from "../../Assets/svg/copyright_logo.svg";

function Footer() {
  const navigate = useNavigate();
  const [direction, setDirection] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [userSubscribe, setUserSubscribe] = useState(false);
  const emailRegex = /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9-]+(\.[a-z0-9-]+)*$/;

  const openWhatsApp = () => {
    const whatsappLink = `https://wa.me/918200550680`;

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      window.location.href = whatsappLink;
    } else {
      window.open(whatsappLink, '_blank');
    }
  };


  const initialState = {
    email: "",
  };
  const ValidationSchema = Yup.object().shape({
    email: Yup.string().required("Email is required*"),
  });

  const clickNextHandler = async (values) => {
    const payload = { ...values };
    try {
      if (emailRegex.test(values.email)) {
        setLoading(true);
        const response = await axios.post(`${baseUrl}${SUBSCRIPTION}`, payload);
        if (response.data.status === 200) {
          setSuccess(response.data.message);
          setError(null);
          setUserSubscribe(true);
          setTimeout(() => {
            formik.resetForm();
            setSuccess(null);
            setUserSubscribe(false);
          }, 2000);
        }
      } else {
        setError("Email address is not valid!!");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(error?.response?.data?.message || "Something Went Wrong!!");
    }
  };

  const formik = useFormik({
    initialValues: initialState,
    validationSchema: ValidationSchema,
    onSubmit: clickNextHandler,
  });

  const setInputValue = useCallback(
    (key, value) =>
      formik.setValues({
        ...formik.values,
        [key]: value,
      }),
    [formik]
  );

  return (
    <React.Fragment>
      <div className="relative w-full text-4xl font-bold footer-gradient md:mt-10 lg:mt-[100px] pb-[25px]">
        <div className="wrapper">
          <div className="flex flex-wrap xl:flex-nowrap w-full justify-start sm:justify-center items-center mt-[50px]">
            <h3 className="max-w-[519px] w-full text-enthusia-primary sm:text-center font-medium whitespace-nowrap leading-[28px] md:leading-[34px] 2xl:leading-[38px]">
              Get latest from Enthusia Softech
            </h3>
            <span className="w-full xl:w-2/3 block h-1 rounded-md from-[#134046] via-[rgba(19,64,70,0.4)] to-[rgba(255,255,255,0.1)] z-10 bg-gradient-to-r order-2 mt-5 xl:mt-0 xl:ml-8"></span>
          </div>
          <div className="flex flex-wrap xl:flex-nowrap w-full justify-start sm:justify-center xl:justify-start">
            <div className="w-full sm:max-w-[519px] text-left pt-3 xl:pt-0">
              <p className="text-enthusia-text sm:text-center xl:text-left leading-6 font-normal pt-[5px] mb-3 sm:mb-[30px]">
                Signup for our newsletter.
              </p>
              <form
                onSubmit={formik.handleSubmit}
                className={`flex relative justify-start items-center ${loading ? "opacity-10" : ""}`}
              >
                <input
                  type="email"
                  name="email"
                  onChange={(e) => setInputValue("email", e.target.value)}
                  value={formik.values.email}
                  className="max-w-[450px] w-full text-lg bg-white border-enthusia-primary border border-r-0 py-2.5 px-4 placeholder:text-sm md:placeholder:text-lg placeholder:text-[#565656] h-[40px] md:h-[44px] lg:h-[50px] focus-within:outline-none font-normal rounded-l-full"
                  placeholder="Enter Your Email"
                />
                <button
                  type="submit"
                  className="relative text-sm md:text-lg leading-6 border-enthusia-primary text-white  bg-gradient-radial h-[40px] md:h-[44px] lg:h-[50px] from-[#225E66] to-[#134046] font-medium border-2 2xl:border-[1px] rounded-r-full rounded-l-[0px] border-l-0 tracking-wider lg:py-2 px-4"
                >
                  {userSubscribe ? "Subscribed" : "Subscribe"}
                  <span className="button-animation"></span>
                </button>
                {formik.errors.email ? (
                  <small className="absolute -bottom-5 text-red-500 font-semibold text-xs pl-5">
                    {formik.errors.email}
                  </small>
                ) : (
                  (error || success) && (
                    <small
                      className={`absolute -bottom-5 font-semibold text-xs ${error !== null ? "text-red-500" : "text-green-600"
                        }`}
                    >
                      {error !== null ? error : success}
                    </small>
                  )
                )}
              </form>
              <div className="hidden xl:flex justify-start text-[#3A6166] capitalize pt-[25px] space-x-8">
                <div
                  onClick={() => navigate("/privacy-policy")}
                  className="text-lg underline font-medium cursor-pointer"
                >
                  Privacy policy
                </div>
                <div
                  onClick={() => navigate("/terms-and-conditions")}
                  className="text-lg underline font-medium cursor-pointer"
                >
                  Terms & conditions
                </div>
              </div>
            </div>
            <div className="flex flex-wrap w-full items-center sm:justify-center pt-5 xl:pt-0">
              <Link
                to={"tel:91 8200550680"}
                target="_blank"
                className="flex items-center text-base md:text-lg font-medium text-enthusia-primary border-[2px] border-l-0 rounded-full bg-white border-[rgba(19, 64, 70, 0.3)] pr-5 m-1 sm:mx-[8px] lg:h-[50px]"
              >
                <div className="relative flex items-center justify-center footer-icon-border border-2 w-10 h-10 lg:w-[50px] lg:h-[50px] rounded-full mr-2 2xl:mr-4">
                  <img
                    src={Call_Icon}
                    alt="call_icon"
                    className="w-auto h-auto p-2 lg:p-0 "
                    loading="lazy"
                  />
                  <span className="button-animation"></span>
                </div>
                +91 82005 50680
              </Link>
              <Link
                to={"mailto:hr@enthusiasoftech.com"}
                target="_blank"
                className="flex items-center text-base md:text-lg font-medium text-enthusia-primary border-[2px] border-l-0 rounded-full bg-white border-[rgba(19, 64, 70, 0.3)] pr-5 m-1 sm:mx-[8px] lg:h-[50px]"
              >
                <div className="relative flex items-center justify-center footer-icon-border border-2 w-10 h-10 lg:w-[50px] lg:h-[50px] rounded-full mr-2 2xl:mr-4">
                  <img
                    src={Email_Icon}
                    alt="email_icon"
                    className="w-auto h-auto p-2 lg:p-0"
                    loading="lazy"
                  />
                  <span className="button-animation"></span>
                </div>
                hr@enthusiasoftech.com
              </Link>
              <div
                onClick={() => setDirection(true)}
                className="relative flex items-center text-base md:text-lg font-medium text-enthusia-primary border-[2px] border-l-0 rounded-full bg-white border-[rgba(19, 64, 70, 0.3)] capitalize pr-5 m-1 sm:mx-[8px] lg:h-[50px] cursor-pointer"
              >
                <div className="relative flex items-center justify-center footer-icon-border border-2 w-10 h-10 lg:w-[50px] lg:h-[50px] overflow-hidden rounded-full mr-2 2xl:mr-4">
                  <img
                    src={Location_Icon}
                    alt="location_icon"
                    className="w-auto h-auto p-2 lg:p-0"
                    loading="lazy"
                  />
                  <span className="button-animation"></span>
                </div>
                get directions!
              </div>
            </div>
            <div className="xl:hidden flex justify-start text-[#3A6166] capitalize pt-3 md:pt-[25px] space-x-5 sm:space-x-8">
              <div
                onClick={() => navigate("/privacy-policy")}
                className="text-sm xsm:text-lg underline font-medium cursor-pointer"
              >
                Privacy policy
              </div>
              <div
                onClick={() => navigate("/terms-and-conditions")}
                className="text-sm xsm:text-lg underline font-medium cursor-pointer"
              >
                Terms & conditions
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Copy Right */}
      <div className="bg-enthusia-primary py-2">
        <div className="wrapper md:flex flex-wrap md:flex-nowrap justify-center md:justify-between items-center md:space-x-3">
          <p onClick={() => navigate("/copyright")} className="md:text-center text-left leading-[25px] font-normal cursor-pointer text-white group">
            Copyright
            <img
              src={CopyrightLogo}
              alt="CopyRight Logo"
              className="w-4 h-4 inline-block group-hover:scale-110 animation mx-1 cursor-pointer"
              loading="lazy"
            />
            2023 Enthusia softech Pvt. Ltd. All Rights Reserved
          </p>
          <div className="md:flex flex-wrap md:flex-nowrap items-center md:space-x-3 mt-5 md:mt-0">
            <p className="block font-normal text-white leading-6 whitespace-nowrap">
              Follow us on :
            </p>
            <div className="flex items-center space-x-3 pt-3 md:pt-0">
              {/* footer Linkedin icon */}
              <Link to="https://www.linkedin.com/company/enthusia-softech/" target="_blank" className="flex items-center justify-center w-[30px] h-[30px] rounded-full border border-white hover:bg-gradient-to-r hover:from-[rgba(255,255,255,1)] hover:to-[rgba(255,255,255,0.58)] cursor-pointer group animation">
                <div className="flex justify-center items-center group-hover:bg-[#0A66C2] w-6 h-6 bg-white rounded-full animation">
                  <svg
                    className="fill-[#134046] group-hover:fill-[#fff]"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M7.92921 6.36475C8.12654 6.14253 8.28832 5.91853 8.49098 5.7283C9.1132 5.14164 9.84921 4.84653 10.7097 4.85364C11.1825 4.8572 11.6483 4.89097 12.1034 5.02253C13.1452 5.32297 13.7497 6.0412 14.0394 7.05808C14.2563 7.82075 14.2954 8.60475 14.2972 9.39053C14.3008 11.0474 14.2919 12.7061 14.2954 14.363C14.2954 14.5176 14.2528 14.5585 14.0999 14.5585C13.2465 14.5514 12.3914 14.5514 11.5381 14.5585C11.387 14.5603 11.355 14.5141 11.355 14.3719C11.3603 12.795 11.3603 11.2181 11.355 9.63941C11.3532 9.24475 11.3283 8.84831 11.2181 8.46431C11.0137 7.75675 10.507 7.39586 9.76565 7.43497C8.75231 7.48831 8.2261 7.98964 8.09632 9.01897C8.0661 9.26431 8.0501 9.51142 8.05188 9.75853C8.05365 11.2927 8.05009 12.827 8.05542 14.3612C8.05542 14.5141 8.0181 14.5585 7.86165 14.5585C7.00121 14.5514 6.14076 14.5514 5.28032 14.5585C5.14165 14.5603 5.10254 14.523 5.10254 14.3825C5.10609 11.3461 5.10609 8.30786 5.10254 5.27141C5.10254 5.1203 5.15232 5.08653 5.29454 5.08653C6.11054 5.09186 6.92831 5.09364 7.74431 5.08653C7.89542 5.08475 7.93277 5.13453 7.93099 5.27675C7.92388 5.63764 7.92921 6.00031 7.92921 6.36475Z" />
                    <path d="M3.25012 9.83389C3.25012 11.3361 3.24834 12.8383 3.25368 14.3406C3.25368 14.5077 3.21279 14.5574 3.04034 14.5557C2.18701 14.5468 1.33367 14.5486 0.478559 14.5539C0.34167 14.5557 0.300781 14.5201 0.300781 14.3797C0.304337 11.3379 0.304337 8.29611 0.300781 5.25256C0.300781 5.12634 0.331011 5.08189 0.464345 5.08189C1.33012 5.08722 2.1959 5.089 3.06167 5.08011C3.22879 5.07834 3.25012 5.14234 3.25012 5.28634C3.24834 6.80456 3.25012 8.31922 3.25012 9.83389Z" />
                    <path d="M3.48481 2.07082C3.48659 3.01482 2.72036 3.78282 1.77814 3.78282C0.848359 3.78282 0.07681 3.01482 0.0732544 2.08505C0.0696989 1.14638 0.841252 0.373047 1.7817 0.373047C2.71503 0.374825 3.48481 1.14104 3.48481 2.07082Z" />
                  </svg>
                </div>
              </Link>
              {/* footer whatsapp icon*/}
              <div onClick={openWhatsApp} target="_blank" className="flex items-center justify-center w-[30px] h-[30px] rounded-full border border-white hover:bg-gradient-to-r hover:from-[rgba(255,255,255,1)] hover:to-[rgba(255,255,255,0.58)] cursor-pointer group animation">
                <div className="flex justify-center items-center group-hover:bg-[#25D366] w-6 h-6 bg-white rounded-full animation">
                  <svg
                    className="group-hover:fill-white fill-enthusia-primary animation"
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M10.2681 8.45713C10.1275 8.3868 9.21317 7.96482 9.07251 7.89449C8.93185 7.82416 8.79119 7.82416 8.65053 7.96482C8.50987 8.10548 8.22856 8.52746 8.0879 8.66812C8.01757 8.80877 7.87691 8.80877 7.73625 8.73845C7.24394 8.52746 6.75164 8.24614 6.32966 7.89449C5.97801 7.54284 5.62636 7.12087 5.34505 6.69889C5.27472 6.55823 5.34505 6.41757 5.41537 6.34724C5.4857 6.27691 5.55603 6.13625 5.69669 6.06592C5.76702 5.99559 5.83735 5.85493 5.83735 5.7846C5.90768 5.71427 5.90768 5.57362 5.83735 5.50329C5.76702 5.43296 5.41537 4.589 5.27472 4.23735C5.20439 3.74505 5.06373 3.74505 4.92307 3.74505H4.57142C4.43076 3.74505 4.21977 3.88571 4.14944 3.95604C3.72747 4.37801 3.51648 4.87032 3.51648 5.43296C3.58681 6.06592 3.7978 6.69889 4.21977 7.26153C4.9934 8.3868 5.97801 9.30108 7.17361 9.86372C7.52526 10.0044 7.80658 10.145 8.15823 10.2154C8.50987 10.356 8.86152 10.356 9.2835 10.2857C9.77581 10.2154 10.1978 9.86372 10.4791 9.44174C10.6198 9.16042 10.6198 8.8791 10.5494 8.59779L10.2681 8.45713ZM12.0264 2.05714C9.2835 -0.685713 4.85274 -0.685713 2.10989 2.05714C-0.140659 4.30768 -0.562636 7.75383 0.984614 10.4967L0 14.0835L3.72747 13.0989C4.78241 13.6615 5.90768 13.9428 7.03295 13.9428C10.9011 13.9428 13.9956 10.8483 13.9956 6.98021C14.0659 5.15164 13.2923 3.3934 12.0264 2.05714ZM10.1275 11.9033C9.21317 12.4659 8.15823 12.8176 7.03295 12.8176C5.97801 12.8176 4.9934 12.5362 4.07911 12.0439L3.86812 11.9033L1.68791 12.4659L2.25055 10.356L2.10989 10.145C0.421977 7.33185 1.26593 3.81538 4.00878 2.05714C6.75164 0.298901 10.2681 1.21318 11.956 3.88571C13.6439 6.62856 12.8703 10.2154 10.1275 11.9033Z" />
                  </svg>
                </div>
              </div>
              {/* footer instagram icon */}
              <Link to="https://www.instagram.com/enthusia_softech?igsh=MTc0dWJ0cHZwb3FnMA==" target="_blank" className="flex items-center justify-center w-[30px] h-[30px] rounded-full border border-white hover:bg-gradient-to-r hover:from-[rgba(255,255,255,1)] hover:to-[rgba(255,255,255,0.58)] cursor-pointer group animation">
                <div className="flex justify-center items-center group-hover:bg-inst-gradient-radial w-6 h-6 bg-white rounded-full animation">
                  <svg
                    className="fill-[#134046] group-hover:fill-white animation"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M7.99972 1.80709C10.0175 1.80709 10.2557 1.8142 11.0522 1.85154C11.7882 1.88531 12.1882 2.00798 12.4548 2.11109C12.8068 2.24798 13.0593 2.41154 13.3242 2.67642C13.589 2.94131 13.7526 3.19198 13.8895 3.54576C13.9926 3.81242 14.1153 4.21242 14.149 4.94842C14.1846 5.74487 14.1935 5.98487 14.1935 8.00087C14.1935 10.0169 14.1864 10.2569 14.149 11.0533C14.1153 11.7893 13.9926 12.1893 13.8895 12.456C13.7526 12.808 13.589 13.0604 13.3242 13.3253C13.0593 13.5902 12.8086 13.7538 12.4548 13.8906C12.1882 13.9938 11.7882 14.1164 11.0522 14.1502C10.2557 14.1858 10.0175 14.1946 7.99972 14.1946C5.98194 14.1946 5.74372 14.1875 4.94727 14.1502C4.21127 14.1164 3.81127 13.9938 3.54461 13.8906C3.19261 13.7538 2.94016 13.5902 2.67527 13.3253C2.41038 13.0604 2.24683 12.8098 2.10994 12.456C2.00683 12.1893 1.88416 11.7893 1.85038 11.0533C1.81483 10.2569 1.80594 10.0169 1.80594 8.00087C1.80594 5.98487 1.81305 5.74487 1.85038 4.94842C1.88416 4.21242 2.00683 3.81242 2.10994 3.54576C2.24683 3.19376 2.41038 2.94131 2.67527 2.67642C2.94016 2.41154 3.19083 2.24798 3.54461 2.11109C3.81127 2.00798 4.21127 1.88531 4.94727 1.85154C5.74372 1.8142 5.98194 1.80709 7.99972 1.80709ZM7.99972 0.445312C5.94816 0.445312 5.69038 0.454201 4.88505 0.491534C4.08149 0.528868 3.53216 0.655091 3.05038 0.843535C2.55438 1.03731 2.13305 1.29509 1.71172 1.71465C1.29216 2.1342 1.0326 2.55553 0.840605 3.05331C0.653938 3.53331 0.525938 4.08265 0.488605 4.88798C0.451271 5.69331 0.442383 5.95109 0.442383 8.00265C0.442383 10.0542 0.451271 10.312 0.488605 11.1173C0.525938 11.9209 0.65216 12.4702 0.840605 12.952C1.03438 13.448 1.29216 13.8693 1.71172 14.2906C2.13127 14.7102 2.55261 14.9698 3.05038 15.1618C3.53038 15.3484 4.07972 15.4764 4.88505 15.5138C5.69038 15.5511 5.94816 15.56 7.99972 15.56C10.0513 15.56 10.309 15.5511 11.1144 15.5138C11.9179 15.4764 12.4673 15.3502 12.949 15.1618C13.445 14.968 13.8664 14.7102 14.2877 14.2906C14.7073 13.8711 14.9668 13.4498 15.1588 12.952C15.3455 12.472 15.4735 11.9226 15.5108 11.1173C15.5482 10.312 15.557 10.0542 15.557 8.00265C15.557 5.95109 15.5482 5.69331 15.5108 4.88798C15.4735 4.08442 15.3473 3.53509 15.1588 3.05331C14.965 2.55731 14.7073 2.13598 14.2877 1.71465C13.8682 1.29509 13.4468 1.03554 12.949 0.843535C12.469 0.656868 11.9197 0.528868 11.1144 0.491534C10.309 0.454201 10.0513 0.445312 7.99972 0.445312Z" />
                    <path d="M7.99923 4.12109C5.85701 4.12109 4.12012 5.85798 4.12012 8.0002C4.12012 10.1424 5.85701 11.8793 7.99923 11.8793C10.1415 11.8793 11.8783 10.1424 11.8783 8.0002C11.8783 5.85798 10.1415 4.12109 7.99923 4.12109ZM7.99923 10.5193C6.60901 10.5193 5.48012 9.3922 5.48012 8.0002C5.48012 6.6082 6.60901 5.48109 7.99923 5.48109C9.38945 5.48109 10.5183 6.6082 10.5183 8.0002C10.5183 9.3922 9.38945 10.5193 7.99923 10.5193Z" />
                    <path d="M12.0336 4.87388C12.5344 4.87388 12.9403 4.46795 12.9403 3.96721C12.9403 3.46648 12.5344 3.06055 12.0336 3.06055C11.5329 3.06055 11.127 3.46648 11.127 3.96721C11.127 4.46795 11.5329 4.87388 12.0336 4.87388Z" />
                  </svg>
                </div>
              </Link>
              {/* footer Thread icon */}
              <Link to="https://www.threads.net/@enthusia_softech" target="_blank" className="flex items-center justify-center w-[30px] h-[30px] rounded-full border border-white hover:bg-gradient-to-r hover:from-[rgba(255,255,255,1)] hover:to-[rgba(255,255,255,0.58)] cursor-pointer group animation">
                <div className="flex justify-center items-center group-hover:bg-[#000000] w-6 h-6 bg-white rounded-full animation">
                  <svg
                    className="fill-[#134046] group-hover:fill-[#fff]"
                    width="14"
                    height="17"
                    viewBox="0 0 14 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M7.41325 0.000318534C7.43632 0.004535 7.45923 0.0118544 7.48238 0.0124908C7.98297 0.0266332 8.48121 0.0865499 8.97087 0.191492C10.0354 0.417828 11.0016 0.851407 11.8354 1.56041C12.5259 2.14753 13.0554 2.85884 13.4546 3.66975C13.6787 4.12473 13.8524 4.59873 13.9886 5.08696C13.9928 5.10192 13.9948 5.11759 14 5.14345L12.6364 5.50749C12.6266 5.4748 12.6184 5.44791 12.6106 5.42086C12.4467 4.85601 12.2262 4.31623 11.9165 3.8147C11.3421 2.88454 10.5402 2.23075 9.51909 1.84434C9.03866 1.66256 8.54119 1.55269 8.0314 1.49271C7.52328 1.43219 7.01038 1.4226 6.50035 1.46407C5.81792 1.52023 5.15522 1.65962 4.52474 1.9352C3.63769 2.32295 2.94682 2.9341 2.44196 3.75798C2.09987 4.31615 1.86844 4.9195 1.70822 5.55197C1.57297 6.08451 1.4923 6.62597 1.44831 7.17332C1.40774 7.67826 1.39389 8.18368 1.42015 8.68981C1.46454 9.5471 1.58196 10.3923 1.8476 11.2117C2.04912 11.8335 2.32891 12.4156 2.72606 12.9381C3.2547 13.6333 3.93379 14.1259 4.74749 14.437C5.21989 14.6177 5.70908 14.7272 6.21052 14.7871C6.66057 14.841 7.11444 14.8557 7.56703 14.8311C8.21 14.7962 8.84152 14.7008 9.44582 14.4667C10.1422 14.1969 10.7291 13.7722 11.2088 13.2017C11.5823 12.7578 11.8161 12.2464 11.8898 11.6693C11.9662 11.0704 11.8842 10.4958 11.5816 9.96461C11.3588 9.57336 11.0368 9.27844 10.6573 9.04264C10.6457 9.03679 10.6337 9.03168 10.6214 9.02736C10.6115 9.0887 10.6022 9.14543 10.5929 9.20239C10.5134 9.69078 10.3843 10.1645 10.1626 10.6093C9.90438 11.1291 9.54638 11.5644 9.05735 11.8849C8.69139 12.1248 8.28836 12.2719 7.85956 12.3518C7.53368 12.4131 7.20152 12.4341 6.87052 12.4144C6.17838 12.3727 5.5378 12.1763 4.98178 11.7492C4.44773 11.339 4.11089 10.8011 4.01725 10.1331C3.86386 9.03675 4.25369 8.16959 5.1728 7.54906C5.5662 7.2831 6.00646 7.12598 6.46884 7.02797C6.92501 6.93091 7.38771 6.91261 7.85184 6.91357C8.29967 6.91326 8.7468 6.94912 9.18886 7.02081C9.19922 7.02145 9.20961 7.02145 9.21996 7.02081C9.21694 6.99638 9.21519 6.97411 9.21137 6.95215C9.17306 6.7275 9.10775 6.5083 9.01686 6.29931C8.79323 5.79183 8.41605 5.46135 7.87794 5.32221C7.39408 5.19707 6.90823 5.19261 6.42524 5.32698C5.98896 5.44831 5.63621 5.69294 5.37224 6.06327C5.3615 6.07839 5.35084 6.09358 5.33947 6.10806C5.33644 6.11188 5.33064 6.11339 5.32093 6.11896L4.16276 5.32436C4.24681 5.19306 4.34091 5.06847 4.44422 4.95172C4.90955 4.42196 5.48728 4.0766 6.17106 3.91025C6.86686 3.74135 7.56401 3.75114 8.25432 3.93579C9.20763 4.19037 9.87996 4.78195 10.2864 5.67806C10.4594 6.05922 10.566 6.4601 10.6243 6.87371C10.6509 7.06234 10.668 7.25223 10.6904 7.45041C10.7131 7.46083 10.7413 7.47428 10.77 7.48685C11.3537 7.74994 11.8758 8.10046 12.3102 8.57469C12.8065 9.11631 13.1118 9.75276 13.2473 10.4723C13.3232 10.8684 13.3437 11.2731 13.3083 11.6747C13.2379 12.4538 12.981 13.1669 12.5304 13.8061C12.0126 14.5405 11.3459 15.1081 10.5559 15.5319C9.9911 15.8348 9.38743 16.0251 8.75798 16.1378C8.15791 16.2457 7.54846 16.2926 6.93894 16.2778C6.11705 16.2572 5.30908 16.1444 4.52561 15.8835C3.07149 15.3994 1.96049 14.4921 1.18299 13.1741C0.770493 12.4748 0.494515 11.7216 0.308433 10.9338C0.179235 10.3866 0.097451 9.83183 0.0495583 9.27176C0.00426813 8.75701 -0.0099991 8.23999 0.00683591 7.72352C0.040488 6.75684 0.162289 5.80289 0.433654 4.87168C0.656411 4.10652 0.973519 3.38399 1.425 2.72479C2.19542 1.59915 3.23155 0.826586 4.52474 0.396984C4.99101 0.242089 5.46882 0.138666 5.95602 0.0771698C6.22421 0.0433585 6.49295 0.0172638 6.76344 0.0120926C6.78929 0.0116153 6.81507 0.00413691 6.84092 0L7.41325 0.000318534ZM9.25895 8.50532C9.24928 8.50012 9.23923 8.49568 9.22888 8.49203C8.90745 8.42527 8.58156 8.38211 8.25384 8.36292C7.9392 8.3437 7.62367 8.3437 7.30903 8.36292C7.00417 8.38121 6.70345 8.42354 6.41276 8.52163C6.14075 8.61344 5.89294 8.74566 5.6946 8.95855C5.25172 9.4339 5.2973 10.1594 5.79564 10.5753C5.94799 10.7026 6.12023 10.7943 6.30734 10.8571C6.82318 11.0299 7.34316 11.0257 7.8625 10.8776C8.23252 10.7721 8.52496 10.5537 8.74557 10.2386C8.86164 10.0727 8.95011 9.89262 9.01972 9.70303C9.14009 9.37558 9.20485 9.0358 9.24248 8.69013C9.24892 8.628 9.25354 8.56562 9.25895 8.50532Z" />
                  </svg>
                </div>
              </Link>
              {/* footer facebook icon*/}
              <Link to="https://www.facebook.com/profile.php?id=61555192523657&mibextid=gik2fB" target="_blank" className="flex items-center justify-center w-[30px] h-[30px] rounded-full border border-white hover:bg-gradient-to-r hover:from-[rgba(255,255,255,1)] hover:to-[rgba(255,255,255,0.58)] cursor-pointer group animation">
                <div className="flex justify-center items-end group-hover:bg-[#1677F0] w-6 h-6 bg-white rounded-full animation">
                  <svg
                    width="11"
                    height="20"
                    viewBox="0 0 11 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="group-hover:fill-white animation"
                      d="M9.6025 10.8126L10.149 7.31508H6.80763V5.06669C6.78436 4.80797 6.81954 4.54733 6.91057 4.30405C7.0016 4.06076 7.14615 3.84105 7.33354 3.66116C7.52093 3.48127 7.74636 3.3458 7.99315 3.26477C8.23995 3.18374 8.5018 3.15922 8.75935 3.19303H10.2739V0.242015C9.38606 0.0939407 8.48832 0.0130395 7.58832 0C4.84809 0 3.06031 1.66287 3.06031 4.68415V7.33069H0V10.8126H3.0525V19.166C4.29378 19.3638 5.55854 19.3638 6.79982 19.166V10.8126H9.6025Z"
                      fill="#134046"
                    />
                  </svg>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <Modal isOpen={direction}>
          <Directions handleClose={setDirection} />
        </Modal>
      </div>
    </React.Fragment>
  );
}

export default Footer;
